/**
 * Переводит фокус на уже открытое окно приложения по клику на уведомление.
 *
 * Раньше обработчик начинался с event.preventDefault(). По спецификации
 * Notifications API действие по умолчанию для клика — как раз «сфокусировать
 * окно, создавшее уведомление», и preventDefault отменял именно его. Оставался
 * только window.focus(), который браузеры из соображений безопасности часто
 * игнорируют — в результате окно не поднималось, и пользователь открывал
 * приложение заново, получая второе окно.
 *
 * Теперь действие по умолчанию не отменяется, а window.focus() остаётся
 * подстраховкой: там, где он работает, окно поднимется быстрее.
 *
 * Полностью надёжного способа сфокусировать существующее окно со страницы нет —
 * это умеет только Service Worker через clients.matchAll() + client.focus().
 * Service Worker'а в проекте пока нет; если проблема останется, правильным
 * решением будет добавить его.
 */
export function focusExistingWindow(): void {
  try {
    window.focus()
  } catch {
    // Браузер вправе запретить фокусировку — это не ошибка, просто игнорируем.
  }
}
